// Admin user-action schemas.
import { z } from 'zod';

import { idSchema, isoTimestampSchema, richTextSchema } from './common.js';

export const suspendUserInputSchema = z.object({
  user_id: idSchema,
  reason: richTextSchema(2000).refine((s) => s.trim().length >= 10, {
    message: 'A specific reason is required for the audit log.',
  }),
  suspension_until: isoTimestampSchema.optional(),
  share_with_user: z.boolean().default(true),
});
export type SuspendUserInput = z.infer<typeof suspendUserInputSchema>;

export const restoreUserInputSchema = z.object({
  user_id: idSchema,
  reason: richTextSchema(2000).optional(),
});
export type RestoreUserInput = z.infer<typeof restoreUserInputSchema>;

export const unsuspendUserInputSchema = restoreUserInputSchema;
export type UnsuspendUserInput = z.infer<typeof unsuspendUserInputSchema>;

export const adminDeleteUserInputSchema = z.object({
  user_id: idSchema,
  reason: richTextSchema(2000),
});
export type AdminDeleteUserInput = z.infer<typeof adminDeleteUserInputSchema>;

export const adminPauseVenueInputSchema = z.object({
  venue_id: idSchema,
  reason: richTextSchema(2000),
});
export type AdminPauseVenueInput = z.infer<typeof adminPauseVenueInputSchema>;

export const adminAnnouncementInputSchema = z.object({
  audience: z.enum(['all', 'artists', 'hosts', 'founding_cohort']),
  title: z.string().min(2).max(200),
  body: richTextSchema(10000),
});
export type AdminAnnouncementInput = z.infer<typeof adminAnnouncementInputSchema>;
